export function formatCurrency(
    amount: number | string,
    currency = "USD",
    locale = "en-US"): string {
    return new Intl.NumberFormat(locale,
        { style: 'currency', currency: currency }).format(+amount);
}